import Feature from 'Services/Feature';

export function useTax() {
    const taxLabel = (tax) => {
        const ratePart = `${tax.rate} %`;
        const base = tax.label ? `${tax.label} - ${ratePart}` : ratePart;
        const systemLabelPart = tax.system_label ? ` - ${tax.system_label}` : '';
        return `${base}${systemLabelPart}`;
    };

    const isEinvoicingCompliant = (tax) => {
        return tax?.is_einvoicing_compliant || !Feature.isEnabled('einvoicing-force-compliant-vat');
    };

    return { taxLabel, isEinvoicingCompliant };
}
